import styles from './gallery-item-placeholder.module.css';

export const GalleryItemPlaceholder = () => {
  return (
    <div className={styles.placeholder}>
      <span>Coming Soon!</span>
    </div>
  );
};
